import { FormattedMessageDiv } from '@odmonorepo/core-components';
import { Stack } from 'react-bootstrap';
import { useIntl } from 'react-intl';

type CustomerServiceInfoCardProps = React.HTMLAttributes<HTMLDivElement>;

export function CustomerServiceInfoCard({ ...props }: CustomerServiceInfoCardProps) {
  const intl = useIntl();
  const phone = intl.formatMessage({ id: 'customerService.phone.number' });
  const email = intl.formatMessage({ id: 'common.customerServiceEmail' });

  return (
    <div {...props}>
      <div className="mx-5 mt-1 mb-4">
        <Stack className="fw-bold">
          <FormattedMessageDiv id="customerService.title.label" />
        </Stack>
        <div className="fs-7">
          <Stack className="text-decoration-none mt-3">
            <a href={`tel:${phone}`}>
              <FormattedMessageDiv id="customerService.phone" />
            </a>
          </Stack>
          <Stack className="text-decoration-none">
            <a href={`mailto:${email}`}>
              <FormattedMessageDiv id="common.customerServiceEmail" />
            </a>
          </Stack>
          <Stack>
            <FormattedMessageDiv id="customerService.fax.label" />
          </Stack>
        </div>
      </div>
    </div>
  );
}

export default CustomerServiceInfoCard;
